import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { BMD } from "us.collection/components";

const Cnt_BMD: React.FC<any> = () => {
  return (<BMD />);
};

export default withRouter(Cnt_BMD);